import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InstallOperator } from "api/controlPlaneApi";

const initialState: InstallOperator = {
  registry: {},
  namespace: "minio-operator",
  namespaces_to_watch: "",
  cluster_domain: "",
  images: {},
};

export const installOperatorSlice = createSlice({
  name: "installOperator",
  initialState,
  reducers: {
    resetInstallOperatorState: () => initialState,
    setNamespace: (state, action: PayloadAction<string>) => {
      state.namespace = action.payload;
    },
    setNamespacesToWatch: (state, action: PayloadAction<string>) => {
      state.namespaces_to_watch = action.payload;
    },
    setClusterDomain: (state, action: PayloadAction<string>) => {
      state.cluster_domain = action.payload;
    },
    setRegistryUrl: (state, action: PayloadAction<string>) => {
      state.registry = { ...state.registry, registry_url: action.payload };
    },
    setRegistryUsername: (state, action: PayloadAction<string>) => {
      state.registry = { ...state.registry, username: action.payload };
    },
    setRegistryPassword: (state, action: PayloadAction<string>) => {
      state.registry = { ...state.registry, password: action.payload };
    },
  },
});

export const {
  resetInstallOperatorState,
  setNamespace,
  setNamespacesToWatch,
  setClusterDomain,
  setRegistryUrl,
  setRegistryUsername,
  setRegistryPassword,
} = installOperatorSlice.actions;
export default installOperatorSlice.reducer;
